import React from 'react';
import { useSelector } from 'react-redux';

import { Layout } from '~/eds/src/components/Layout/Layout';
import { Text } from '~/eds/src/components/Text/Text';
import { useIntl } from 'react-intl';
import { slices } from '~/redux/slices';

import { calculateF1Score } from '../../util';

const AccuracyMetrics = () => {
  const intl = useIntl();
  const model = useSelector(slices.automation.selectors.selectAutomationModel);
  const metrics = model?.current?.accuracyMetrics || {};
  const f1Score = calculateF1Score(metrics) ?? 0;

  return (
    <Layout
      direction="column"
      borderRadius="m"
      border="border.divider"
      mb={4}
      p={4}
    >
      <Text variant="body-bold">
        {intl.formatMessage({
          id: 'AccuracyMetrics.detailsTitle',
          defaultMessage: 'Details',
          description: 'Title for accuracy metrics details section',
        })}
      </Text>
      <Layout justify="space-between" pt={2}>
        <Text>
          {intl.formatMessage({
            id: 'AccuracyMetrics.inSamplePrecisionLabel',
            defaultMessage: 'In-Sample Precision',
            description: 'Label for in-sample precision',
          })}
        </Text>
        <Text variant="body-bold">{metrics?.inSample?.precision}</Text>
      </Layout>
      <Layout justify="space-between" pt={2}>
        <Text>
          {intl.formatMessage({
            id: 'AccuracyMetrics.inSampleRecallLabel',
            defaultMessage: 'In-Sample Recall',
            description: 'Label for in-sample recall',
          })}
        </Text>
        <Text variant="body-bold">{metrics?.inSample?.recall}</Text>
      </Layout>
      <Layout justify="space-between" pt={2}>
        <Text>
          {intl.formatMessage({
            id: 'AccuracyMetrics.outOfSamplePrecisionLabel',
            defaultMessage: 'Out-of-Sample Precision',
            description: 'Label for out-of-sample precision',
          })}
        </Text>
        <Text variant="body-bold">{metrics?.outOfSample?.precision}</Text>
      </Layout>
      <Layout justify="space-between" pt={2}>
        <Text>
          {intl.formatMessage({
            id: 'AccuracyMetrics.outOfSampleRecallLabel',
            defaultMessage: 'Out-of-Sample Recall',
            description: 'Label for out-of-sample recall',
          })}
        </Text>
        <Text variant="body-bold">{metrics?.outOfSample?.recall}</Text>
      </Layout>
      <Layout justify="space-between" pt={2}>
        <Text>
          {intl.formatMessage({
            id: 'AccuracyMetrics.f1ScoreLabel',
            defaultMessage: 'F1 Score',
            description: 'Label for F1 score',
          })}
        </Text>
        <Text variant="body-bold">{f1Score}</Text>
      </Layout>
      <Layout justify="space-between" pt={2}>
        <Text>
          {intl.formatMessage({
            id: 'AccuracyMetrics.thresholdLabel',
            defaultMessage: 'Threshold',
            description: 'Label for threshold value',
          })}
        </Text>
        <Text variant="body-bold">{model?.current?.threshold}</Text>
      </Layout>
    </Layout>
  );
};

export default AccuracyMetrics;
